import React from "react";
import { Label, ToggleButton } from "react-aria-components";
import { useFormContext } from "react-hook-form";

type ToggleBtn = {
  label?: string;
  name: string;
  btnName?: string;
};

export default function ToggleButtonUi({
  label,
  name,
  btnName,
  ...props
}: ToggleBtn) {
  const {
    setValue,
    getValues,
    clearErrors,
    formState: { errors },
  } = useFormContext();
  const filedName = name || "";
  const errorMessage = errors[filedName] || {
    message: "",
  };
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const error = errorMessage?.message?.toString() || "";

  const value = getValues(filedName);
  return (
    <div>
      <Label className="font-medium">{label}</Label>
      <ToggleButton
        isSelected={value}
        onChange={(e) => {
          clearErrors(filedName);
          setValue(filedName, e);
        }}
        className={`focus:outline-none`}
        {...props}
      >
        {({ isSelected }) => (
          <div
            className={`${
              isSelected
                ? "bg-indigo-600 text-white"
                : " text-gray-600 border border-gray-400"
            } text-xs w-12 h-7 flex items-center justify-center rounded-md focus:outline-none `}
          >
            {btnName}
          </div>
        )}
      </ToggleButton>
    </div>
  );
}
